import styled, { css } from 'styled-components';

export const CardEmpty = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 16px;
    justify-content: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      text-align: center;
    }
  `}
`;

export const WrapperImage = styled.div`
  ${({ theme, width }) => css`
    align-items: center;
    display: flex;
    height: 186px;
    justify-content: center;
    position: relative;

    ${width === '100' && css`
      @media (min-width: ${theme.v2.breakpoints.md}) {
        height: 186px;
      }
    `}

    ${width !== '100' && css`
      @media (min-width: ${theme.v2.breakpoints.md}) {
        height: 200px;
        width: 360px;
      }
    `}
  `}
`;

export const WrapperDescription = styled.div`
  ${({ theme }) => css`
    max-width: 383px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 90%;
    }
  `}
`;

export const CardEmptyTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const CardEmptySubtitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
